import React from 'react';
import moment from 'moment';
import { FaClock } from 'react-icons/fa';

/**
 * Componente selector de hora
 */
const TimeSelector = ({ 
  selectedDate, 
  selectedTime, 
  onSelectTime, 
  isTimeSlotAvailable,
  getCapacidadInfo,
  timeSlots
}) => {
  const formattedDate = selectedDate.format('dddd, D [de] MMMM');

  return (
    <div className="bg-gray-800 rounded-lg p-4 border border-gray-700 shadow-md h-full">
      <div className="flex items-center mb-4">
        <FaClock className="mr-2 text-blue-400" />
        <h3 className="text-lg font-medium">Horarios disponibles para {formattedDate}</h3>
      </div>
      
      <div className="grid grid-cols-3 gap-2 max-h-[400px] overflow-y-auto">
        {timeSlots.map((time, index) => {
          const isAvailable = isTimeSlotAvailable(selectedDate, time);
          const isSelected = selectedTime && time.format('HH:mm') === selectedTime.format('HH:mm');
          const capacidadInfo = getCapacidadInfo ? getCapacidadInfo(selectedDate, time) : null;
          
          // Determinar clases según disponibilidad y selección
          let timeClasses = "py-2 px-3 rounded-lg text-center transition-colors";
          let tooltip = isAvailable ? 'Seleccionar este horario' : 'Horario no disponible';
          
          if (isSelected) {
            timeClasses += " bg-blue-600 text-white";
          } else if (isAvailable) {
            timeClasses += " bg-gray-700 hover:bg-gray-600 cursor-pointer";
          } else {
            timeClasses += " bg-gray-800 text-gray-500 line-through cursor-not-allowed";
          }
          
          // Agregar información de capacidad al tooltip si está disponible
          if (capacidadInfo && capacidadInfo.capacidad > 1) {
            if (isAvailable) {
              tooltip = `Disponible (${capacidadInfo.disponible}/${capacidadInfo.capacidad} libres)`;
            } else {
              tooltip = `Ocupado (${capacidadInfo.ocupados}/${capacidadInfo.capacidad} clientes)`;
            }
          }
          
          return (
            <div
              key={index}
              className={timeClasses}
              onClick={() => isAvailable && onSelectTime(time)}
              title={tooltip}
            >
              <div className="text-sm font-medium">
                {time.format('HH:mm')}
              </div>
              {capacidadInfo && capacidadInfo.capacidad > 1 && (
                <div className="flex justify-center gap-1 mt-1">
                  {Array.from({ length: capacidadInfo.capacidad }).map((_, i) => (
                    <div 
                      key={i} 
                      className={`w-2 h-2 rounded-full ${i < capacidadInfo.disponible ? 'bg-green-500' : 'bg-gray-500'}`}
                    />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimeSelector;
